import { IKnmEvent248 } from '../../../../../APIPackage/KnmModule/interfaces/IKnmEvent248';
import { IKnmSubject248 } from '../../../../../APIPackage/KnmModule/interfaces/IKnmSubject248';
import { IPmSubject } from '../../../../../APIPackage/KnmModule/interfaces/IPm';
import { IKnmObject248 } from '../../../../../APIPackage/KnmModule/interfaces/IKnmObject248';
import { IKnmRequirementsNpa248 } from '../../../../../APIPackage/KnmModule/interfaces/IKnmRequirementsNpa248';
import { IKnmRequirementsNpa } from '../../../../../APIPackage/KnmModule/interfaces/IKnmRequirementsNpa';
import { IDecisionOrganization } from '../../../../../APIPackage/DecisionModule/interfaces/IDecisionOrganization';

export const convertEventsFromLink = (events: IKnmEvent248[] | null | undefined): IKnmEvent248[] | null => {
  return (
    events?.map(event => ({
      ...event,
      suspension: null,
      originalStopDate: undefined,
      isFilledFromLink: true,
    })) ?? null
  );
};

export const convertErknmOrganizationsFromLink = (
  organizations: IKnmSubject248[] | null | undefined,
): IKnmSubject248[] | null => {
  return (
    organizations?.map(org => ({
      ...org,
      isFilledFromLink: true,
    })) ?? null
  );
};

export const convertPmOrganizationsFromLink = (organization: IPmSubject | null | undefined): IPmSubject[] | null => {
  return organization
    ? [
        {
          ...organization,
          isFilledFromLink: true,
        },
      ]
    : [];
};

export const convertObjectsFromLink = (objects: IKnmObject248[] | null | undefined): IKnmObject248[] | null => {
  return (
    objects?.map(obj => ({
      ...obj,
      isFilledFromLink: true,
    })) ?? null
  );
};

export const convertErknmRequirementsFromLink = (
  requirements: IKnmRequirementsNpa248[] | null | undefined,
): IKnmRequirementsNpa248[] | null => {
  return (
    requirements?.map(requirement => ({
      ...requirement,
      isFilledFromLink: true,
    })) ?? null
  );
};

export const convertPmRequirementsFromLink = (
  requirements: IKnmRequirementsNpa[] | null | undefined,
): IKnmRequirementsNpa[] | null => {
  return (
    requirements?.map(requirement => ({
      ...requirement,
      isFilledFromLink: true,
    })) ?? null
  );
};

export const convertDecisionOrganizationToSubject = (org: IDecisionOrganization): IKnmSubject248[] => [
  {
    inn: org.inn,
    ogrn: org.ogrn,
    position: null,
    okveds: null,
    addressFns: null,
    organizationName: org.name,
    firstOrganizationName: null,
    mspCode: org.mspCode,
    checkSubjectResult: org.checkSubjectResult,
    dateCreate: null,
    act: null,
    resultDecisions: null,
    isAutocomplete: org.isAutocomplete,
    isFiz: null, // TODO: в IDecisionOrganization нет isFiz — при необходимости вывести из organizationType
    guid: org.guid,
    isDocumentOrganization: null,
    nkoForeignAgentsRegistryNumber: org.nkoForeignAgentsRegistryNumber,
    nkoForeignAgentsRegistryInclusionDate: org.nkoForeignAgentsRegistryInclusionDate,
    nkoForeignAgentsRegistryExclusionDate: org.nkoForeignAgentsRegistryExclusionDate,
    isNko: org.isNko,
    subjectType: org.organizationType,
    rafpNza: org.rafpNza,
    smevRequestStatus: org.smevRequestStatus,
    kpp: org.kpp,
    isForeignSubjectAgencyNotRegistredInRf: org.isForeignSubjectAgencyNotRegisteredInRf,
    country: org.country,
    isSonko: org.isSonko,
    locationAddress: org.locationAddress,
    workAddress: org.workAddress,
    factualAddress: org.factualAddress,
    snils: org.snils,
    document: org.document,
    epguNotifications: org.epguNotifications,
    ervkId: org.ervkId,
    isPresentInItRegistry: org.isPresentInItRegistry,
    itAccreditationResponse: org.itAccreditationResponse,
    smevItAccreditationRequestStatus:
      typeof org.smevItAccreditationRequestStatus === 'string' ? org.smevItAccreditationRequestStatus : null,
    isNew: null,
    isFilledFromLink: null,
    locationRegion: org.locationRegion,
    locationNotInFIAS: org.locationNotInFIAS,
    locationManualAddress: org.locationManualAddress,
    locationFiasRegion: org.locationFiasRegion,
    locationRegionCodeFromFns: org.locationRegionCodeFromFns,
  },
];
